const TOKEN_KEY = 'hp_jf_token';
const USER_KEY = 'hp_jf_user';

export function saveAuth(token, user) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getUser() {
  const raw = localStorage.getItem(USER_KEY);
  return raw ? JSON.parse(raw) : null;
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export function isAuthenticated() {
  return Boolean(getToken());
}

export function getHomePathForRole(role) {
  if (role === 'ADMIN') return '/admin';
  if (role === 'TEAM_LEAD') return '/team-lead/home';
  if (role === 'RECRUITER') return '/recruiter/home';
  return '/';
}